import { Component, ElementRef, Inject, OnInit, ViewChild, TemplateRef, Output, NgZone } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
// import { Util } from "util/Util";
import { DomSanitizer } from '@angular/platform-browser';
import { LDataSource, TableOptions, RowFields } from '../../../../../tsScripts/DTO/TableDTO';
import { ModalAddProfile } from './ModalAddProfile';
import { ModalEditProfile } from './ModalEditProfile';
import { ModalDeleteProfile } from './ModalDeleteProfile';
import { MessageStorage } from '../../../../../tsScripts/util/MessageStorage';
import { ActivatedRoute } from '@angular/router';


declare let ENDPOINT_LUDYAPI: string;
declare let NAMESPACE_LUDYACCOUNT: string;
declare let $: any;


@Component({
    selector: 'profile-information-list',
    templateUrl: "../../../../../views/components/support/companies/profile/profileInformationList.html",
    providers:[LDataSource]
})

export class ProfileInformationList implements OnInit {

    private companyId: string;
    tableOptions: TableOptions;
    swValid: boolean;
    closeResult: string;
    constructor(private zone: NgZone,
        private lDataSource: LDataSource,
        private routeLocation: ActivatedRoute,
        private modalService: NgbModal,
        private domSanitizer: DomSanitizer) {

        this.companyId = this.routeLocation.snapshot.queryParams.companyId;
        this.lDataSource.url = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/company/profiles";
        this.lDataSource.method = "put";
        this.lDataSource.root = "profiles";
        this.tableOptions = new TableOptions();
        this.swValid = false;
    }





    refresh() {
        this.tableOptions.dataSource.load({ companyId: this.companyId });
        if (this.tableOptions.clearRowSelected != null) {
            this.tableOptions.clearRowSelected();
        }
    }

    public refreshTap(value: boolean) {
        if (value) {
            this.zoneInit();
        }
    }

    private fillTable() {
        this.tableOptions.rowId = "registerId";
        this.tableOptions.multiSelect = true;

        this.tableOptions.columns.push(new RowFields("profileName", "Nombre"));

        this.tableOptions.columns.push(new RowFields("profileDescription", "Descripción"));

        /*this.tableOptions.columns.push(new RowFields("isActive", "Activo", (isActive) => {
            return ProfileInformationList.renderYes_No(isActive + "");
        }));*/

        this.tableOptions.columns.push(new RowFields("createDate", "Fecha de Creación"));

        this.tableOptions.dataSource = this.lDataSource;
    }

    public static renderYes_No(_value: string): string {
        if (_value == '0') {
            return "<span class='label label-default'>No</span>";
        } else {
            return "<span class='label label-primary'>Si</span>";
        }
    }

    addProfile() {
        let modalRef: NgbModalRef = this.modalService.open(ModalAddProfile, { backdrop: "static" });
        modalRef.componentInstance.selected = this.tableOptions.selectedRows;
        modalRef.result.then(null, (reasonDismiss) => {
            this.refresh();
        });
    }

    editProfile() {
        if (this.tableOptions.selectedRows.length > 0 && this.tableOptions.selectedRows.length < 2) {
            let modalRef: NgbModalRef = this.modalService.open(ModalEditProfile, { backdrop: "static" });
            modalRef.componentInstance.selected = this.tableOptions.selectedRows[0];
            modalRef.result.then(null, (reasonDismiss) => {
                this.refresh();
            });
        } else {
            if (this.tableOptions.selectedRows.length > 1) {
                MessageStorage.add("error", "Debe seleccionar solo un perfil.");
            } else {
                MessageStorage.add("error", "Debe seleccionar al menos  un perfil.");
            }

        }
    }

    deleteProfile() {
        if (this.tableOptions.selectedRows.length > 0) {
            let modalRef = this.modalService.open(ModalDeleteProfile);
            modalRef.componentInstance.selected = this.tableOptions.selectedRows;
            modalRef.result.then(null, () => {
                this.tableOptions.clearRowSelected();
                this.refresh();
            });
        } else {
            MessageStorage.add("error", "Debe seleccionar al menos un archivo");
        }
    }

    validEnabled(value) {
        if (value > 0 && value < 2) {
            return true;
        } else {
            return false;
        }
    }

    zoneInit() {
        this.fillTable();
        this.refresh();
    }

    ngOnInit() {
        /*this.zone.run(() => {
            this.fillTable();
            this.refresh();
        });*/
        this.fillTable();
        setTimeout(() => {
            this.refresh();
        }, 100);
    }
}